import { API } from "../Client";
import { NewsItem } from "./types";

namespace NewsService {
    /**
       * Fetches trusted news for this stock or crypto
       *
       * @param symbols list of stock/crypto tickers
       * @param isCrypto
       * @param limit defaults to 50
       * @param sort
       * @returns latest news for given stock/crypto
       */
    export async function getNews(symbols: string[], isCrypto: boolean = false, limit: number = 50, sort: 'ASC' | 'DESC' = 'DESC'): Promise<NewsItem[]> {
        // if (isCrypto) {
        //     symbols = symbols.map((s) => {
        //         const isCrypto = CryptoStocks.isCrypto(s);
        //         const sym = CryptoStocks.clean(s);
        //         return isCrypto ? `${sym}USD` : sym;
        //     });
        // }

        const res = await API.get('/news', {
            params: {
                symbols: symbols.slice(0, 8),
                isCrypto,
                limit,
                sort,
            },
        });

        return res?.data || [];
    }

    /**
       * Fetches latest general news about the stock market
       *
       * @param limit
       * @returns latest news
       */
    export async function getLatestGeneralNews(limit: number = 10): Promise<NewsItem[]> {
        const res = await API.get('/news/general', {
            params: {
                limit,
            },
        });

        return res?.data || [];
    }

}

export default NewsService;
